/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    loginButton: {
        innerHTML: "Se connecter"
    },
    loginInProgress: "Connexion en cours...",
    loginInput: {
        placeholder: "Identifiant"
    },
    passwordInput: {
        placeholder: "Mot de passe"
    }
};